export default {"src":"/_next/static/media/vector.3b64387d.svg","height":10,"width":10};